/**
 * Admin ThemeProvider — light by default; dark only when user toggles.
 * Preference persists in `localStorage` key `rpapp-admin-theme` (this browser only).
 */

import { ThemeProvider as SharedThemeProvider } from 'pi-kiosk-shared/theme';
import type { ReactNode } from 'react';
import { ADMIN_THEME_STORAGE_KEY, adminThemeOptions } from './theme.js';

export interface ThemeProviderProps {
  children: ReactNode;
}

export function ThemeProvider({ children }: ThemeProviderProps): JSX.Element {
  return (
    <SharedThemeProvider
      storageKey={ADMIN_THEME_STORAGE_KEY}
      lightOverrideEnabled={adminThemeOptions.lightOverrideEnabled}
      defaultPreference={adminThemeOptions.defaultPreference}
      systemResolvesTo={adminThemeOptions.systemResolvesTo}
    >
      {children}
    </SharedThemeProvider>
  );
}
